/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { finalize, map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';

import { NzModalService } from 'ng-zorro-antd/modal';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  AuthService,
  AppOptionsService,
  NotificationService,
  BaseSourceService,
  DynamicFormService,
  ErrorsHandlingService,
  ViewerRestrictionService
} from '../../../core/services';
import { HelpersInterface } from '../../../core/interfaces';
import { CompanyInterface, PartnerInterfaceGlobal, PlatformInterface } from '../../../core/models';
import { ErrorValidator } from '../../../core/validators';

import {
  checkboxesForUpdateForm,
  macrosListScriptWeb,
  macrosListApp,
  macrosListServerWeb,
  macrosListGoogleAds,
  macrosListMobup,
  jsTagTypes,
  removedRTBFields,
  checkboxesRTB,
  removedVastFields,
  vastCheckboxes,
  removedPreBidFields,
  preBidCheckboxes,
  removedJsFields,
  jsCheckboxes,
  urlAttrsSSP
} from '../../../core/constants';

import { CompaniesTestLinkComponent } from '../../companies/modals';
import { DeleteEndpointConfirmComponent, NotificationComponent } from '../../../shared/components';
import { RtbConnectionMode, UserRole } from '../../../core/enum';
import { updateCheckedStatus, getEndpointsCheckedKeys, getStringCheckedKeys, rearrangeFilterListItems, rearrangeCompaniesItems, transformArray } from '../../../core/helpers';

import { MacrosListComponent } from '../components';
import {
  defaultMacrosListVast,
  urlVastAttributes,
  requiredFields,
  connectionTypesNames,
  endpointValidationStatusItems,
  sizesListForEditSSPModal,
  allowCountriesTriggerForSSPModal,
  pubWritingItemsForSSPModal,
  impTriggeringItems,
  fraudItemsForSSPModal,
  requiredMacrosForSSPModal,
  MainDashboardInterface,
  apiLinkValidationStatus,
  DEFAULT_MIMES_ITEMS,
  SKIP_ITEMS,
  STARTDELAY_ITEMS,
  PLACEMENT_ITEMS,
  PLCMT_ITEMS,
  POSITION_ITEMS,
  PLAYBACKMETHOD_ITEMS,
  PROTOCOLS_ITEMS,
  API_PROTOCOLS_ITEMS,
  MIMES_AUDIO_ITEMS,
} from '../models';
import { MainService } from './main.service';

interface AccType {
  selectedMacros: string[];
  macroses: MainDashboardInterface.IVastMacros[];
}

@Injectable({
  providedIn: 'root'
})
export class EditSspService {
  public editSSPForm: FormGroup;
  public tabIndex = 0;
  public apiLink = '';
  public userRole: UserRole;

  public RtbConnectionMode = RtbConnectionMode;
  public jsTagTypes = jsTagTypes;
  public connectionTypesNames = connectionTypesNames;
  public macrosListVast: MainDashboardInterface.IVastMacros[] = defaultMacrosListVast;
  public endpointValidationStatus = endpointValidationStatusItems;

  public apiLinkValidationStatus = apiLinkValidationStatus;

  public skipItems = SKIP_ITEMS;
  public startDelayItems = STARTDELAY_ITEMS;
  public placementItems = PLACEMENT_ITEMS;
  public plcmtItems = PLCMT_ITEMS;
  public positionItems = POSITION_ITEMS;
  public playbackmethodItems = PLAYBACKMETHOD_ITEMS;
  public protocolsItems = PROTOCOLS_ITEMS;
  public apiProtocolsItems = API_PROTOCOLS_ITEMS;
  public mimesItems = DEFAULT_MIMES_ITEMS;

  public isRequiredTrafficType = false;
  public isRequiredAdFormat = false;
  public isRequiredCompany = false;
  public isRequiredRegion = false;
  public isDisableSubmit = false;
  public isDisableDuplicate = false;
  public isOpenMacros = false;
  public isShowFields = false;
  public isDisabledTest = false;
  public hasScanner: boolean;

  public adaptersItem: PlatformInterface.IRtbAdaptersItem | null = null;
  public partnerSettings: PartnerInterfaceGlobal.IPartnerSettings;

  public macrosListJs: any[] = [];
  public listOfMacros: MainDashboardInterface.IVastMacros[] = [];
  public companies: CompanyInterface.ICompany[] = [];
  public regions: { id: string, name: string }[] = [];
  public filterLists: HelpersInterface.IFilterListsItems[] = [];
  public rtbAdapters: { id: number | string; name: string, config, disabled?: boolean }[] = [];
  public adaptersRtb: any[] = [];
  public listOfSizes: { id: number, width: number, height: number, name: string }[] = [];
  public blockedIabCategories: HelpersInterface.ITressSelectItem[] = [];
  public iabCategories: HelpersInterface.ITressSelectItem[] = [];
  public categories: { id: string; name: string }[] = [];

  public sizesList: { id: string, name: string }[] = sizesListForEditSSPModal;

  public allowCountriesTrigger = allowCountriesTriggerForSSPModal;

  public pubWritingItems = pubWritingItemsForSSPModal;

  public impTriggeringItems = impTriggeringItems;

  public fraudItems = fraudItemsForSSPModal;

  private get partner(): PartnerInterfaceGlobal.IPartnerGeneral {
    return this._partner;
  }

  private set partner(value: PartnerInterfaceGlobal.IPartnerGeneral) {
    this._partner = value;
  }

  private get endpoint(): PlatformInterface.IPlatformSSP {
    return this._endpoint;
  }

  private set endpoint(value: PlatformInterface.IPlatformSSP) {
    this._endpoint = value;
  }

  private get dspList(): PlatformInterface.IPlatformDSP[] {
    return this._dspList;
  }

  private set dspList(value: PlatformInterface.IPlatformDSP[]) {
    this._dspList = value;
  }

  private requiredFields = requiredFields;
  private cookieSync: any;

  private url: string;
  private selectedJs: string[] = [];
  private macrosListDialogJs: any[] = [];

  private macrosListScriptWeb: { id: string, name: string, desc: string }[] = macrosListScriptWeb;
  private macrosListApp: { id: string, name: string, desc: string }[] = macrosListApp;
  private macrosListServerWeb: { id: string, name: string, desc: string }[] = macrosListServerWeb;
  private macrosListGoogleAds: { id: string, name: string, desc: string }[] = macrosListGoogleAds;
  private macrosListMobup: { id: string, name: string, desc: string }[] = macrosListMobup;

  private jsMacrosList = {
    web: this.macrosListScriptWeb,
    app: this.macrosListApp,
    serverWeb: this.macrosListServerWeb,
    serverApp: this.macrosListApp,
    googleAd: this.macrosListGoogleAds,
    macrosListMobup: this.macrosListMobup
  };

  private _dspList: PlatformInterface.IPlatformDSP[] = [];

  private protocol: string;
  private urlJSAttrs = urlAttrsSSP;
  private urlAttrsVast = urlVastAttributes;

  private requiredMacros = requiredMacrosForSSPModal;

  private rtbServers: PlatformInterface.IRtbAdaptersItem[] = [];
  private adaptersFields: { field: string | number, id: string, config }[] = [];
  private fieldsAdapters: any[] = [];
  private selectedAdapterName: string;

  private marginKeys: {
    min_margin: string;
    max_margin: string;
    margin: string;
  } = {
      min_margin: 'Minimum Margin',
      max_margin: 'Maximum Margin',
      margin: 'Margin',
    };

  private arrayOfMargins: { key: string, minValue: number, maxValue: number }[] = [];
  private selectedMacrosesCache: string[] = [];
  private _companiesDSPDropdown: HelpersInterface.ITressSelectItem[] = [];

  private _isShowPartnerNameForPrebid = true;
  private _isShowPartnerNameForPrebidJS = true;

  private endpointId: number;
  private _partner: PartnerInterfaceGlobal.IPartnerGeneral;
  private _endpoint: PlatformInterface.IPlatformSSP;

  private apiUrl: string;

  constructor(
    private options: AppOptionsService,
    private auth: AuthService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    private notificationComponent: NotificationComponent,
    private baseSourceService: BaseSourceService,
    private loadingService: NgxSpinnerService,
    private dynamicFormService: DynamicFormService,
    private errorsHandlingService: ErrorsHandlingService,
    private mainService: MainService,
    private viewerRestrictionService: ViewerRestrictionService,
    private http: HttpClient,
  ) {
    this.apiUrl = this.options.getApiUrl();
    this.createForm();
    this.hasScanner = this.baseSourceService.hasScanner;
  }

  public get isUserViewer(): boolean {
    return this.auth.userRole === UserRole.viewer;
  }

  public isShowSkipFields(): boolean {
    return this.formValue.vast.skip === 1;
  }

  get isShowDemandBooster(): boolean {
    if (this.isJSConnection()) {
      return true;
    } else if (!this.isVastConnection() && this.formValue['isBanner']) {
      return true;
    } else {
      return false;
    }
  }

  public get isDisabledSubmitBtn(): boolean {
    return this.isDisableSubmit || this.isUserViewer;
  }

  public getTooltipForHuaweiAdapter(name: string): string {
    return name === 'Huawei' && !this.isOnlyNativeSelected()
      ? 'Available only with the Native ad format' :
      '';
  }

  public get adTypeControlValue(): string {
    return this.editSSPForm.get('adtype')?.value || '';
  }

  public set companiesDSPDropdown(value: HelpersInterface.ITressSelectItem[]) {
    this._companiesDSPDropdown = value;
  }

  public get companiesDSPDropdown(): HelpersInterface.ITressSelectItem[] {
    return this._companiesDSPDropdown;
  }

  public restrictionTooltipForVastExtensions(): string {
    return this.partner?.partner_plan !== 1 ? 'VAST Extensions are available on Enterprise version. If you want to upgrade your platform, please contact our Business Development Manager' : '';
  }

  public restrictionTooltipMessage(field: string): string {
    return this.partner?.partner_plan === 3 ? `${field} is available on Plus and Enterprise versions.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public restrictionTooltipMessageForButton(connectionType: number): string {
    const restrictedConnectionTypes = [4, 5];
    return this.partner?.partner_plan === 3 && restrictedConnectionTypes.includes(connectionType) ? `The endpoint is not available for editing because your current plan no longer supports the connection type of this endpoint.
       If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public initializeComponent(data: MainDashboardInterface.IEditSSPDialog) {
    this.createForm();
    this.initializeDropdowns(data);
    this.filterCompanies(data);
    this.loadPartnerSettings(data);
    this.loadOptions();
    this.loadAuthDetails();
    this.getDSPEndpoints();
  }

  public onValidateSpaceForNameHandler() {
    const nameControl = this.formControls['name'];
    if (nameControl.errors?.whitespace) {
      this.showNotification('error', 'error', 'error', '', 'Name cannot start with whitespace', '', '385px', 4500, 'normal');
    }
  }

  public isShowStartDelayMidControls(): boolean {
    return this.formValue.vast.startdelay === 1;
  }

  public onChangeTrafficTypeHandler(): void {
    this.setSelectedMacrosList();
  }

  public getIsRequiredAdapterField(itemName: string): boolean {
    const config = this.adaptersItem?.config;

    if (this.isConfigValid(config)) {
      return config.paramsReq[itemName]?.required ?? false;
    }

    return false;
  }

  public get isShowPartnerNameForPrebid(): boolean {
    return this._isShowPartnerNameForPrebid;
  }

  public set isShowPartnerNameForPrebid(value: boolean) {
    this._isShowPartnerNameForPrebid = value;
  }

  public get isShowPartnerNameForPrebidJS(): boolean {
    return this._isShowPartnerNameForPrebidJS;
  }

  public set isShowPartnerNameForPrebidJS(value: boolean) {
    this._isShowPartnerNameForPrebidJS = value;
  }

  public get isShowImpTriggering(): boolean {
    return [0, 4, 5].includes(this.formValue['connectionType']);
  }

  public get selectedSizesControl(): FormControl {
    return this.editSSPForm.get('vast')?.get('selectedSizes') as FormControl;
  }

  public get endpointControl(): FormControl {
    return this.editSSPForm.get('endpoint') as FormControl;
  }

  public get isShowJSMacros(): boolean {
    if (this.jsTagTypeFormControl) {
      return ['web', 'app', 'serverWeb', 'serverApp'].includes(this.jsTagTypeFormControl.value);
    } else {
      return false;
    }
  }

  public get fixedBidPriceControl(): FormControl {
    return this.editSSPForm.get('fixedBidPrice') as FormControl;
  }

  public get formValue() {
    return this.editSSPForm.getRawValue();
  }

  public onChangeTabHandler(event: number): void {
    this.tabIndex = event;
  }

  public onCompanyChangeHandler(): void {
    this.isRequiredCompany = this.formValue.companyId == null;
  }

  public isTMTEnabled() {
    return this.auth.partner.useTMT;
  }

  public isNovoroll() {
    return this.auth.partner.id === 76;
  }

  public onChangeSizeHandler(id: number): void {
    const elementSize = id ? this.listOfSizes.find(element => element.id === id) : { width: null, height: null };
    if (elementSize) {
      this.jsControls['w'].patchValue(elementSize.width);
      this.jsControls['h'].patchValue(elementSize.height);
    }
  }

  public isBotmanPreBidIsEnabled(): boolean {
    return !!this.auth.partner.botman_settings?.enable_prebid;
  }

  public isBotmanPostBidIsEnabled(): boolean {
    return !!this.auth.partner.botman_settings?.enable_postbid;
  }

  public isFraudSensorEnabled(): boolean {
    return !!this.partnerSettings.use_fraud_sensor;
  }

  public isMediaGuardEnabled(): boolean {
    return !!this.partnerSettings.use_media_guard;
  }

  public isFraudLogixEnabled(): boolean {
    return !!this.partnerSettings.useFraudlogix;
  }

  public onChangeChecked(value: boolean, element: string): void {
    if (element === 'isBanner' && !value) {
      this.formControls['has_demand_booster'].patchValue(false);
    }

    if (this.isRTBConnection()) {
      this.onSetHuaweiAdapterByAdFormat();
    }
  }

  public onChangeVideoFormatHandler(enableVideo: boolean): void {
    this.formControls['isVideo'].patchValue(enableVideo, { emitEvent: false });

    if (this.isVastConnection()) {
      this.onChangeVastMacrosByFormat(enableVideo);

      if (enableVideo) {
        this.formControls['vast']?.get('mimes')?.patchValue([
          'video/mp4',
          'video/mpeg',
          'video/ogg',
          'video/webm',
          'application/javascript'

        ]);
      }

      this.updateControlsBasedOnPartnerPlan();
    }
  }

  public onChangeAudioFormatHandler(enableAudio: boolean): void {
    this.formControls['isAudio'].patchValue(enableAudio, { emitEvent: false });

    if (this.isVastConnection()) {
      if (enableAudio) {
        this.formControls['vast']?.get('mimes')?.patchValue(['audio/mp4']);
        this.mimesItems = MIMES_AUDIO_ITEMS;
      } else {
        this.formControls['vast']?.get('mimes')?.patchValue([
          'video/mp4',
          'video/mpeg',
          'video/ogg',
          'video/webm',
          'application/javascript'
        ]);

        this.mimesItems = DEFAULT_MIMES_ITEMS;
      }

      this.updateControlsBasedOnPartnerPlan();
    }
  }

  public onChangeRewardedFormatHandler(enableRewarded: boolean): void {
    this.formControls['rewarded'].patchValue(enableRewarded, { emitEvent: false });
    this.updateControlsBasedOnPartnerPlan();
  }

  public onChangePixalatePreBidIpHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ip_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidIFAHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ifa_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidBundleHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('hr_app_percent')?.patchValue(0, { emitEvent: false });
    }
  }


  public onSubmitFormHandler(callback: (type: string) => void): void {
    const restrictedConnectionTypes = [4, 5];

    if (this.partner.partner_plan === 3 && restrictedConnectionTypes.includes(this.formValue.connectionType)) {
      this.viewerRestrictionService.restrictByPartnerPlan();
      return;
    }

    if (this.userRole === UserRole.viewer) {
      this.viewerRestrictionService.restrictUserViewer();
      return;
    }

    this.isDisableSubmit = true;
    if (!this.handleErrors()) {
      this.isDisableSubmit = false;
      return;
    }

    this.handleCookieSync();
    this.handleMarginType();

    const modifiedDSPList = getEndpointsCheckedKeys(this.companiesDSPDropdown);

    this.handleSubmitByConnectionType(modifiedDSPList, callback);
  }

  public onCloseModalHandler(callback: () => void): void {
    this.tabIndex = 0;
    callback();
  }

  public async onApiLinkTestHandler(link: string, e: MouseEvent): Promise<void> {
    e.preventDefault();
    const resp = await this.mainService.testApiLink(link);
    this.modalService.create({
      nzMaskClosable: false,
      nzContent: CompaniesTestLinkComponent,
      nzData: {
        apitest: resp,
      }
    });
    return;
  }

  public onCopyLinkHandler(event: MouseEvent, label: string): void {
    (event.target as HTMLButtonElement).textContent = 'Copied!';
    setTimeout(() => { (event.target as HTMLButtonElement).textContent = label; }, 1200);
  }


  public onChangeCustomAdapterHandler(server: string | number): void {
    if (server === null) return;

    this.resetAdaptersFields();
    this.findAdapterItem(server);
    this.setupAdaptersRtb();
  }

  public onDeleteEndpointHandler(endpoint: PlatformInterface.IPlatformSSP, callback: (type: string) => void): void {
    const dialogRef = this.createDeleteEndpointDialog(endpoint);

    this.handleDialogClose(dialogRef, endpoint, callback);
  }

  public onDuplicateEndpointHandler(endpointId: number, callback: (type: string) => void): void {
    this.loadingService.show();
    this.mainService.duplicateEndpointReq(endpointId, 'ssp')
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe({
        next: () => {
          this.showSuccessNotificationAndCloseModal('Endpoint is duplicated!');
          callback('updated');
        },
        error: (err) => this.errorsHandlingService.handleError(err)
      });
  }

  public onValidateLinkHandler(link: string, event: Event): void {
    event.preventDefault();
    this.apiLink = link;
    this.isDisabledTest = false;
  }

  public getError(value: boolean): void {
    this.isDisabledTest = value;
  }

  public onShowMacrosListHandler(macrosListContentHeight: string, macrosListBodyHeight: string): void {
    this.modalService.create({
      nzContent: MacrosListComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'macros-list-modal',
      nzWrapClassName: 'macros-list-modal-wrap',
      nzStyle: { top: '30px', width: '650px', height: macrosListContentHeight },
      nzBodyStyle: { width: '650px', padding: '0px', height: macrosListBodyHeight, overflowY: 'scroll' },
      nzData: {
        macrosList: this.isVastConnection() ? this.listOfMacros : this.macrosListDialogJs,
      }
    });
    return;
  }


  public onTagTypeChangeHandler(type: string): void {
    if (type === 'direct') {
      this.handleDirectType();
      return;
    }

    this.restoreSelectedJsFromCache();
    this.clearSelectedJs();
    this.updateMacrosListsBasedOnType(type);
    this.removeUserIdMacro();
    this.updateJsMacrosListControl();
    this.onChangeMacrosJsHandler(this.selectedJs);
  }

  private handleDirectType(): void {
    this.selectedMacrosesCache = this.selectedJs;
    this.selectedJs = [];
    this.onChangeMacrosJsHandler([]);
  }

  private restoreSelectedJsFromCache(): void {
    if (this.selectedMacrosesCache.length > 0) {
      this.selectedJs = this.selectedMacrosesCache;
    }
  }

  private clearSelectedJs(): void {
    this.selectedJs = [];
  }

  private updateMacrosListsBasedOnType(type: string): void {
    switch (type) {
      case 'web':
      case 'serverWeb':
        this.setMacrosList(this.macrosListScriptWeb);
        break;
      case 'app':
      case 'serverApp':
        this.setMacrosList(this.macrosListApp);
        break;
      case 'googleAd':
        this.setMacrosList(this.macrosListGoogleAds);
        break;
      case 'mobup':
        this.setMacrosList(this.macrosListMobup);
        break;
    }
  }

  private setMacrosList(list: any[]): void {
    this.macrosListJs = list;
    this.macrosListDialogJs = list;
    list.forEach(m => this.selectedJs.push(m.id));
  }

  private removeUserIdMacro(): void {
    const index = this.selectedJs.indexOf('[USER_ID]');
    if (index !== -1) {
      this.selectedJs.splice(index, 1);
    }
  }

  private updateJsMacrosListControl(): void {
    this.jsMacrosListControl?.patchValue(this.selectedJs);
  }

  public onChangeMacrosJsHandler(selectedItems: string[]): void {
    // Handle null/undefined selectedItems gracefully
    if (!selectedItems || !Array.isArray(selectedItems)) {
      selectedItems = [];
    }

    this.selectedJs = [...new Set(this.getMandatoryMacroses().concat(selectedItems))];
    const macrosList = this.selectedJs;
    let attributes = this.urlJSAttrs;
    let baseUrl = `https://${this.partnerSettings.ns}/?c=rtb&m=js`;
    let typeParam = '';
    let tag = '<script type="text/javascript" src="{url}"></script>';

    switch (this.jsTagTypeFormControl?.value) {
      case 'web':
      case 'app':
        typeParam = '&type=s2c';
        break;
      case 'serverWeb':
      case 'serverApp':
        typeParam = '&type=s2s';
        break;
      case 'googleAd':
        typeParam = '&type=dfp';
        tag = '<script type="text/javascript"src="{url}"></script>';
        break;
      case 'mobup':
        typeParam = '&type=mopub';
        tag = `<script type="text/javascript">
                var p = document.currentScript;
                var s = document.createElement("script");
                s.src = "{url}&ifa=%eudid!";
                p.insertAdjacentElement("afterend", s);
              </script>`;
        break;
      default:
        baseUrl = `https://${this.partnerSettings.ns}/?c=rtb&m=direct`;
        tag = '<script async type="text/javascript"src="{url}"></script>';
        break;
    }

    this.url = `${baseUrl}${typeParam}&seat=${this.formValue.seat}&token=${this.formValue.secretKey}`;
    macrosList.forEach(macro => {
      this.url += `&${attributes[macro] || ''}=${macro}`;
    });

    this.url = tag.replace('{url}', this.url);
    this.editSSPForm.get('endpoint')?.patchValue(this.url);
  }

  public onChangeVastMacrosHandler(selectedItems: string[]): void {
    let url = `${this.protocol}${this.partnerSettings.ns}/?seat=${this.formValue.seat}&token=${this.setOriginalEndpointUrl()}`;
    const adServerMacros = this.vastFormGroupValue['adServerId'] != null ? this.vastFormGroupValue['adServer'].macroses : null;

    // Handle null/undefined selectedItems gracefully
    if (!selectedItems || !Array.isArray(selectedItems)) {
      this.editSSPForm.get('endpoint')?.patchValue(url);
      return;
    }

    selectedItems.forEach(item => {
      let attrValue = this.urlAttrsVast[item];
      let value = item;

      if (adServerMacros) {
        const macro = adServerMacros.find(m => m.shortcut === item && m.showAttr === 1);
        if (macro) {
          attrValue = macro.shortcut;
          value = macro.macros;
        }
      }

      url += `&${attrValue}=${value}`;
    });

    this.editSSPForm.get('endpoint')?.patchValue(url);
  }

  public onShowVastMacrosesHandler(): void {
    this.isOpenMacros = !this.isOpenMacros;
  }

  public onSizeChangeHandler(selected: string): void {
    if (selected === '0') {
      this.vastControls['w'].patchValue(null);
      this.vastControls['h'].patchValue(null);
    }

    if (selected === '1') {
      this.vastControls['w'].addValidators([Validators.required]);
      this.vastControls['h'].addValidators([Validators.required]);
      this.editSSPForm.get('vast')?.get('h')?.setErrors({ invalid: false });
      this.editSSPForm.get('vast')?.get('w')?.setErrors({ invalid: false });
    }
  }

  public isVastConnection(): boolean {
    return this.formValue['connectionType'] === 1;
  }

  public isPreBidConnection(): boolean {
    return this.formValue['connectionType'] === 4;
  }

  public isPrebidJsConnection(): boolean {
    return this.formValue['connectionType'] === 5;
  }

  public isRTBConnection(): boolean {
    return this.formValue['connectionType'] === 0;
  }
  public isJSConnection(): boolean {
    return this.formValue['connectionType'] === 3;
  }

  public onChangeDefaultBidfloor() {
    this.formControls['fixedPrice'].patchValue(this.fixedBidPriceControl.value > 0);
  }

  public get pixalatePreBidSettingsControls(): { [key: string]: FormControl } {
    return (this.editSSPForm.get('pixalate_pb_settings') as FormGroup).controls as { [key: string]: FormControl };
  }

  public onChangeBCATCheckboxStateHandler(value: boolean): void {
    switch (value) {
      case true:
        break;
      default:
        this.formControls['iab_bcat'].patchValue([]);
        break;
    }
  }

  public onChangeIABCategoriesCheckboxStateHandler(value: boolean): void {
    switch (value) {
      case true:
        break;
      default:
        this.formControls['iab_cat'].patchValue([]);
    }
  }

  public onPreventInputHandler(event: Event, field: string): void {
    const value = this.pixalatePBSettingsControls[field].value;

    if (value > 100) {
      event.preventDefault();

      return this.pixalatePBSettingsControls[field].patchValue(parseInt(value.toString().substring(0, 2)));
    }

    if (value < 0) {
      event.preventDefault();

      return this.pixalatePBSettingsControls[field].patchValue(0);
    }
  }

  public onChangeMarginTypeHandler(type: string): void {
    this.changeStatusForBidPriceControl(type);
    switch (this.formValue.margin_type) {
      case 'range':
        this.handleRangeMargin();
        break;
      case 'fixed':
        this.handleFixedMargin();
        break;
      case 'adaptive':
        this.handleAdaptiveMargin();
        break;
    }
  }

  private isConfigValid(config: any): boolean {
    return config && !Array.isArray(config) && Object.keys(config).length > 0;
  }

  private handleRangeMargin(): void {
    this.arrayOfMargins = [
      { key: 'min_margin', minValue: 1, maxValue: 100 },
      { key: 'max_margin', minValue: 1, maxValue: 100 }
    ];
    this.resetMarginValue();
  }

  private handleFixedMargin(): void {
    this.arrayOfMargins = [{ key: 'margin', minValue: 0, maxValue: 100 }];
    this.resetMinMaxMarginValues();
  }

  private handleAdaptiveMargin(): void {
    this.arrayOfMargins = [];
    this.resetAllMarginValues();
  }

  private resetMarginValue(): void {
    this.formControls.margin.patchValue(undefined);
  }

  private resetMinMaxMarginValues(): void {
    this.formControls.min_margin.patchValue(undefined);
    this.formControls.max_margin.patchValue(undefined);
  }

  private resetAllMarginValues(): void {
    this.resetMarginValue();
    this.resetMinMaxMarginValues();
  }

  private changeStatusForBidPriceControl(type: string): void {
    if (type !== 'fixed') {
      this.formControls['has_maximised_bidprice'].patchValue(false);
      this.formControls['has_maximised_bidprice'].disable();
    } else {
      this.formControls['has_maximised_bidprice'].patchValue(false);
      this.formControls['has_maximised_bidprice'].enable();
    }
  }

  private handleErrors() {
    this.markAllControlsAsTouched();

    let errorMessages: string[] = [];
    if (this.tabIndex === 0) {
      errorMessages = this.collectTabErrors(errorMessages);
      errorMessages = this.collectRequiredFieldErrors(errorMessages);
      errorMessages = this.collectMacroErrors(errorMessages);
    }

    if (this.isVastConnection()) {
      errorMessages = this.validateMidRollStartDelay(errorMessages);
      errorMessages = this.validateVastEnhancementFields(errorMessages);
      errorMessages = this.validateSkipMin(errorMessages);
      errorMessages = this.validateSkipAfter(errorMessages);
    }

    errorMessages = this.validateMultiAdResponses(errorMessages);

    if (this.isRTBConnection()) {
      errorMessages = this.validateCustomAdapterHuawei(errorMessages);
    }

    if (this.isVastConnection()) {
      errorMessages = this.validateMacrosRequirement(errorMessages);
    }

    if (errorMessages.length) {
      this.displayErrorMessages(errorMessages);
      return false;
    }

    return true;
  }

  private markAllControlsAsTouched() {
    Object.values(this.editSSPForm.controls).forEach(control => control.markAsTouched());
  }

  private collectTabErrors(errorMessages: string[]): string[] {
    errorMessages = this.validateTrafficType(errorMessages);
    errorMessages = this.validateAdFormat(errorMessages);
    errorMessages = this.validateCompany(errorMessages);
    errorMessages = this.validateRegion(errorMessages);
    errorMessages = this.validateMargin(errorMessages, this.arrayOfMargins);
    errorMessages = this.validateName(errorMessages);

    if (this.isJSConnection()) {
      errorMessages = this.validateBidFloor(errorMessages);
      errorMessages = this.validateJsHeight(errorMessages);
      errorMessages = this.validateJsWidth(errorMessages);
      errorMessages = this.validateSpendLimit(errorMessages);
    }


    if (this.isVastConnection()) {
      errorMessages = this.validateVastBidfloor(errorMessages);
      errorMessages = this.validateVastHeight(errorMessages);
      errorMessages = this.validateVastWidth(errorMessages);
    }

    return errorMessages;
  }

  private validateCustomAdapterHuawei(errorMessages: string[]): string[] {
    if ((!this.isOnlyNativeSelected() && this.selectedAdapterName === 'Huawei')) {
      errorMessages.push('The endpoint could not be generated because Huawei adaptor works only with the Native ad format. Please make the necessary changes');
    }

    return errorMessages;
  }

  private collectRequiredFieldErrors(errorMessages: string[]): string[] {
    Object.entries(this.requiredFields).forEach(([key, value]) => {
      if (this.tabIndex === 0 && this.editSSPForm.controls[key]?.status === 'INVALID') {
        errorMessages.push(`${value} is required`);
      }
    });
    return errorMessages;
  }

  private collectMacroErrors(errorMessages: string[]): string[] {
    if (!this.validateRequiredMacros()) {
      if (['mobile_web', 'desktop'].includes(this.adTypeControl.value)) {
        errorMessages.push('At least one macros of [PAGE_URL], [DOMAIN] is required');
      }
      if (['mobile_app', 'ctv'].includes(this.adTypeControl.value)) {
        errorMessages.push('macros [APP_BUNDLE] is required');
      }
    }
    return errorMessages;
  }

  private displayErrorMessages(errorMessages: string[]): void {
    errorMessages.forEach(errorMessage =>
      this.showNotification('error', 'error', 'error', '', errorMessage, '', '415px', 4500, 'normal'));
  }

  private validateVastEnhancementFields(errors: string[]): string[] {
    const vastControls = this.formControls['vast'];

    const controlKeys = [
      'minduration',
      'maxduration',
    ];

    const controlNames = {
      minduration: 'Min Duration',
      maxduration: 'Max Duration',
    };

    controlKeys.forEach(controlKey => {
      if (vastControls.get(controlKey)?.value === null) {
        errors.push(`${controlNames[controlKey]} is required`);
      }

      if (vastControls.get(controlKey)?.value !== null && vastControls.get(controlKey)?.value < 0) {
        errors.push(`${controlNames[controlKey]} cannot be less than 0`);
      }
    });

    return errors;
  }

  private validateSkipMin(errors: string[]): string[] {
    const skipMinControl = this.editSSPForm.get('vast')?.get('skipmin');
    const skiipControl = this.editSSPForm.get('vast')?.get('skip');

    if (skiipControl?.value === 1) {
      if (skipMinControl?.value === null) {
        errors.push('Skip Min is required');
      }

      if (skipMinControl?.value !== null && skipMinControl?.value < 0) {
        errors.push('Skip Min cannot be less than 0');
      }
    }

    return errors;
  }

  private validateSkipAfter(errors: string[]): string[] {
    const skipAfterControl = this.editSSPForm.get('vast')?.get('skipafter');
    const skiipControl = this.editSSPForm.get('vast')?.get('skip');

    if (skiipControl?.value === 1) {
      if (skipAfterControl?.value === null) {
        errors.push('Skip After is required');
      }

      if (skipAfterControl?.value !== null && skipAfterControl?.value < 0) {
        errors.push('Skip After cannot be less than 0');
      }
    }

    return errors;
  }

  private validateMidRollStartDelay(errors: string[]): string[] {
    const startdelaymidControl = this.editSSPForm.get('vast')?.get('startdelaymid');

    if (this.editSSPForm.get('vast')?.get('startdelay')?.value !== 1) {
      return errors;
    }

    if (startdelaymidControl?.value === null) {
      errors.push('Mid-roll start delay is required');
    }

    if (startdelaymidControl?.value !== null && startdelaymidControl?.value < 1) {
      errors.push('Mid-roll start delay cannot be less than 1');
    }

    if (startdelaymidControl?.value !== null && startdelaymidControl?.value > 3000) {
      errors.push('Mid-roll start delay cannot be greater than 3000');
    }

    return errors;
  }

  private validateCompany(errors: string[]): string[] {
    this.isRequiredCompany = (this.formValue.companyId === undefined || this.formValue.companyId === null);

    if (this.isRequiredCompany) {
      errors.push('Company is required');
    }

    return errors;
  }

  private validateRegion(errors: string[]): string[] {
    this.isRequiredRegion = (this.formValue.region === undefined || this.formValue.region === null);

    if (this.isRequiredRegion) {
      errors.push('Region is required');
    }

    return errors;
  }

  private validateAdFormat(errors: string[]) {
    const { isBanner, isNative, isVideo, rewarded, isAudio } = this.formValue;

    if (this.isRTBConnection() || this.isVastConnection() || this.isPreBidConnection() || this.isPrebidJsConnection()) {
      if (!(isBanner || isNative || isVideo || rewarded || isAudio)) {
        errors.push('Please select at least one ad format.');
      }
    }

    return errors;
  }

  private validateTrafficType(errors: string[]): string[] {
    if (!this.isJSConnection()) {
      const checkedAtLeastOneType = this.checkTrafficType();
      this.isRequiredTrafficType = !checkedAtLeastOneType;
      if (!checkedAtLeastOneType) {
        errors.push('Please select at least one traffic type.');
      }
    }
    return errors;
  }

  private validateVastHeight(errors: string[]): string[] {
    const vastControl = this.editSSPForm.get('vast');
    const heightControl = vastControl?.get('h');
    if (heightControl?.errors?.required && this.isVastConnection()) {
      errors.push('Height is required');
      heightControl.setErrors({ invalid: true });
      heightControl.markAsTouched();
    }
    return errors;
  }

  private validateVastWidth(errors: string[]): string[] {
    const vastControl = this.editSSPForm.get('vast');
    const widthControl = vastControl?.get('w');
    if (widthControl?.errors?.required && this.isVastConnection()) {
      errors.push('Width is required');
      widthControl.setErrors({ invalid: true });
      widthControl.markAsTouched();
    }
    return errors;
  }

  private validateJsHeight(errors: string[]): string[] {
    const jsControl = this.editSSPForm.get('js');
    const heightControl = jsControl?.get('h');
    if (!this.formValue.js.h && this.isJSConnection()) {
      errors.push('Height is required');
      heightControl?.setErrors({ invalid: true });
      heightControl?.markAsTouched();
    }
    return errors;
  }

  private validateJsWidth(errors: string[]): string[] {
    const jsControl = this.editSSPForm.get('js');
    const widthControl = jsControl?.get('w');
    if (!this.formValue.js.w && this.isJSConnection()) {
      errors.push('Width is required');
      widthControl?.setErrors({ invalid: true });
      widthControl?.markAsTouched();
    }
    return errors;
  }

  private validateSpendLimit(errors: string[]): string[] {
    if (!this.formValue.spendLimit) {
      errors.push('Spend Limit is required');
    }
    return errors;
  }

  private validateBidFloor(errors: string[]): string[] {
    const bidFloor = this.formValue.js.bidfloor;

    if (!bidFloor) {
      errors.push('Fixed Bidfloor is required');
    }

    if (bidFloor < 0) {
      errors.push('The minimal Fixed Bidfloor value cannot be less than 0');
    }

    return errors;
  }

  private validateVastBidfloor(errors: string[]): string[] {
    const bidFloor = this.formValue.vast.bidfloor;

    if (!bidFloor) {
      errors.push('Fixed Bidfloor is required');
    }

    if (bidFloor < 0.01) {
      errors.push('The minimal Fixed Bidfloor value cannot be less than 0.01');
    }

    return errors;
  }

  private validateMargin(errors: string[], arrayOfMargins: { key: string, minValue: number, maxValue: number }[]): string[] {
    this.validateMarginRange(errors);
    arrayOfMargins.forEach(margin => this.validateMarginValue(margin, errors));
    return errors;
  }

  private validateMarginRange(errors: string[]): void {
    if (
      this.formValue.margin_type === 'range' &&
      this.formValue.min_margin >= this.formValue.max_margin &&
      ((this.formValue.min_margin || this.formValue.max_margin) !== null)
    ) {
      this.setMarginError('min_margin');
      this.setMarginError('max_margin');
      errors.push('Maximum margin value must be greater than minimum margin value');
    }
  }

  private validateMarginValue(margin: { key: string, minValue: number, maxValue: number }, errors: string[]): void {
    const marginValue = this.formValue[margin.key];
    if (marginValue !== null && marginValue !== undefined) {
      if (marginValue < margin.minValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be lower than ${margin.minValue}`);
      } else if (marginValue > margin.maxValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be higher than ${margin.maxValue}`);
      }
    } else {
      errors.push(`${this.marginKeys[margin.key]} is required`);
    }
  }

  private setMarginError(controlName: string): void {
    this.editSSPForm.controls[controlName].setErrors({ invalid: true });
  }

  private validateName(errors: string[]): string[] {
    const { name } = this.editSSPForm.controls;
    const maxLengthError = name.errors?.maxlength;
    const requiredError = name.errors?.required;
    if (maxLengthError) {
      errors.push(`You have reached your maximum limit of characters allowed. Required length is ${maxLengthError.requiredLength}, but you entered ${maxLengthError.actualLength}`);
    }

    if (requiredError) {
      errors.push('Name is required');
    }

    return errors;
  }

  private validateMacrosRequirement(errorMessages: string[]): string[] {
    if (!this.validateRequiredMacros()) {
      if (['mobile_web', 'desktop'].includes(this.adTypeControlValue)) {
        errorMessages.push('At least one macros of [PAGE_URL], [DOMAIN] is required');
      }

      if (['mobile_app', 'ctv'].includes(this.adTypeControlValue)) {
        errorMessages.push('macros [APP_BUNDLE] is required');
      }
    }
    return errorMessages;
  }

  private getAdType() {
    const adTypeMappings = {
      'mobile_web': 'mobile_web',
      'desktop': 'desktop',
      'mobile_app': 'mobile_app',
      'ctv': 'ctv'
    };
    this.setAdType(this.formValue, adTypeMappings, this.adTypeControl, 'mobile_web');
  }

  private getJsAdType(): void {
    const jsAdTypeMappings = {
      'mobile_web': 'mobile_web',
      'mobile_app': 'mobile_app',
      'desktop': 'desktop'
    };
    this.setAdType(this.formValue, jsAdTypeMappings, this.jsAdTypeControl, 'mobile_web');
  }

  private setAdType(source: any, mappings: { [key: string]: string }, control: any, defaultValue: string): void {
    for (const key in mappings) {
      if (source[key]) {
        control.patchValue(mappings[key]);
        return;
      }
    }
    if (control.value === '') {
      control.patchValue(defaultValue);
    }
  }

  private validateRequiredMacros() {
    if (this.formValue.connectionType !== 1 || this.vastFormGroupValue['adServerId'] != null) {
      return true;
    }

    let existRequiredMacros = false;
    for (let i = 0; i < this.vastFormGroupValue['macrosList'].length; i++) {
      if (this.requiredMacros[this.adTypeControl.value].indexOf(this.vastFormGroupValue['macrosList'][i]) !== -1) {
        existRequiredMacros = true;
        break;
      }
    }

    return existRequiredMacros;
  }

  private get jsMacrosListControl(): FormControl | null {
    return this.editSSPForm.get('js')?.get('macrosList') as FormControl;
  }

  private get jsTagTypeFormControl(): FormControl | null {
    return this.editSSPForm.get('js')?.get('tagType') as FormControl;
  }

  private get adTypeControl(): FormControl {
    return this.editSSPForm.get('adtype') as FormControl;
  }

  private get jsAdTypeControl(): FormControl {
    return this.editSSPForm.get('jsAdType') as FormControl;
  }

  private get formControls(): { [key: string]: FormControl } {
    return this.editSSPForm.controls as { [key: string]: FormControl };
  }

  private get jsControls(): { [key: string]: FormControl } {
    return (this.editSSPForm.get('js') as FormGroup).controls as { [key: string]: FormControl };
  }

  private get vastControls(): { [key: string]: FormControl } {
    return (this.editSSPForm.get('vast') as FormGroup).controls as { [key: string]: FormControl };
  }

  private get vastFormGroupValue() {
    return (this.editSSPForm.get('vast') as FormGroup).value;
  }

  private get pixalatePBSettingsControls(): { [key: string]: FormControl } {
    return (this.editSSPForm.get('pixalate_pb_settings') as FormGroup).controls as { [key: string]: FormControl };
  }

  private getMatchingElements(arr1: MainDashboardInterface.IVastMacros[], arr2: string[]): MainDashboardInterface.IVastMacros[] {
    let result: MainDashboardInterface.IVastMacros[] = [];
    for (let i = 0; i < arr1.length; i++) {
      if (arr2.includes(arr1[i].id)) {
        result.push(arr1[i]);

      }
    }
    return result;
  }

  private handleJs(): void {
    this.getJsAdType();
    this.jsTagTypeChanged(this.jsTagTypeFormControl?.value);

    this.selectedJs = this.formValue.js.macrosList;
    this.macrosListDialogJs = this.jsMacrosList[this.jsTagTypeFormControl?.value];

    this.updateSelectedSizeBasedOnDimensions();
  }

  private updateSelectedSizeBasedOnDimensions(): void {
    const height = this.jsControls['h'].value;
    const width = this.jsControls['w'].value;

    if (height == null || width == null) {
      this.editSSPForm.get('selectedSize')?.patchValue(0);
    } else if (!this.isSizeValid(height, width)) {
      this.formControls['selectedSize'].patchValue(0);
    } else {
      this.recognizeSelectedSize();
    }
  }

  private isSizeValid(height: number, width: number): boolean {
    const heightExists = this.listOfSizes.some(element => element.height === height);
    const widthExists = this.listOfSizes.some(element => element.width === width);
    return heightExists && widthExists;
  }

  private recognizeSelectedSize(): void {
    const selectedSize = this.listOfSizes.find(size =>
      size.height === this.formValue.js.h && size.width === this.formValue.js.w
    );
    this.formControls['selectedSize'].patchValue(selectedSize ? selectedSize.id : 0);
  }

  private getMandatoryMacroses(): string[] {
    const webTypes = ['web', 'serverWeb', 'app', 'serverApp'];
    if (webTypes.includes(this.jsTagTypeFormControl?.value)) {
      return ['[IP]', '[UA]'];
    }
    return [];
  }

  private checkTrafficType(): boolean {
    if (this.isRTBConnection() || this.isPrebidJsConnection() || this.isPreBidConnection()) {
      return this.checkStandardTrafficTypes();
    } else if (this.isVastConnection()) {
      return this.checkVastTrafficType();
    }
    return false;
  }

  private checkStandardTrafficTypes(): boolean {
    const { mobile_web, desktop, mobile_app, ctv } = this.formValue;
    return mobile_web || desktop || mobile_app || ctv;
  }

  private checkVastTrafficType(): boolean {
    const { adtype } = this.formValue;
    return ['mobile_web', 'mobile_app', 'desktop', 'ctv'].includes(adtype);
  }

  private getBlockedIabCategoriesCheckedKeys(): string[] {
    const checkedKeys: string[] = [];

    const processElement = (element: HelpersInterface.ITressSelectItem) => {
      if (element.checked) {
        checkedKeys.push(element.key);
      }

      if (Array.isArray(element.children)) {
        element.children.forEach(child => processElement(child));
      }
    };

    this.blockedIabCategories.forEach(element => processElement(element));

    return checkedKeys;
  }

  private getIABCategoriesCheckedKeys(): string[] {
    const checkedKeys: string[] = [];

    const processElement = (element: HelpersInterface.ITressSelectItem) => {
      if (element.checked) {
        checkedKeys.push(element.key);
      }

      if (Array.isArray(element.children)) {
        element.children.forEach(child => processElement(child));
      }
    };

    this.iabCategories.forEach(element => processElement(element));

    return checkedKeys;
  }

  private getIABCategories(): void {
    this.mainService.getFilterValuesByKeyReq({ filters: ['iabCategories'] })
      .subscribe(res => {
        this.iabCategories = res.iabCategories;
        this.blockedIabCategories = res.iabCategories;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private isOnlyNativeSelected(): boolean {
    const {
      isBanner,
      isNative,
      isVideo,
      rewarded,
      isAudio
    } = this.editSSPForm.value;
    return isNative && !isBanner && !isVideo && !rewarded && !isAudio;
  }

  private processAdaptersResponse(res): void {
    const fieldsNone = this.createNoneAdapter();
    this.rtbServers = [fieldsNone, ...res];
    this.rtbAdapters = this.rtbServers.map(item => ({
      id: item.id,
      name: item.name,
      config: item.config,
      disabled: false,
    }));

    let huaweiAdapter = this.rtbAdapters.find(adapter => adapter.name === 'Huawei');
    if (huaweiAdapter && !this.isOnlyNativeSelected()) huaweiAdapter.disabled = true;
  }

  private onSetHuaweiAdapterByAdFormat(): void {
    let huaweiAdapter = this.rtbAdapters.find(adapter => adapter.name === 'Huawei');
    if (huaweiAdapter) {
      if (this.isOnlyNativeSelected()) {
        huaweiAdapter.disabled = false;
      } else {
        huaweiAdapter.disabled = true;
      }
    }
  }

  private createNoneAdapter(): any {
    return {
      name: 'None',
      id: 0,
      fields: [],
      config: {},
    };
  }

  private updateAdaptersForRubicon(): void {
    this.rtbServers = this.rtbServers.map(item => {
      if (item.name === 'Rubicon' && !this.partnerSettings.has_rubicon_settings) {
        item.name = 'Rubicon Inactive';
      }
      return item;
    });
  }

  private setSelectedAdapter(): void {
    const adaptersItem = this.rtbServers.find(item => item.id === this.formValue.adapter_id) || null;
    if (adaptersItem) {
      this.adaptersItem = adaptersItem;
      this.selectedAdapterName = adaptersItem.name;
    }
  }

  private cleanupRBTFormValue(): void {
    delete this.formValue.vastConnectionMode;
  }

  private setupRTBEndpoint(): void {
    this.endpoint = {
      ...this.formValue,
      adapter_id: this.formValue.adapter_id,
      connectionType: 0,
      active: this.formValue.active,
    };
  }

  private buildAdapterConfig(): any {
    const fields: any = {};
    this.fieldsAdapters = [];
    if (this.adaptersFields.length === 0) {
      this.fieldsAdapters = [];
      return fields;
    }

    this.adaptersFields.forEach(value => {
      fields[value.id] = value.field;
    });

    if (!this.validateFields(fields)) {
      return false;
    }

    this.fieldsAdapters.push(fields);

    return fields;
  }

  private validateFields(fields: any): boolean {
    for (const field in fields) {
      if (this.adaptersItem.config.paramsReq[field]?.required && (fields[field] === null || fields[field].length === 0)) {
        this.showNotification('error', 'error', 'error', '', `${field} is required`, '', '385px', 4500, 'normal');
        return false;
      }
    }

    return true;
  }

  private prepareRTBEndpointData(modifiedDSPList: number[]): any {
    const blockedIabCategories = getStringCheckedKeys(this.blockedIabCategories);
    const iabCategories = getStringCheckedKeys(this.iabCategories);

    return {
      ...this.formValue,
      connectionType: this.formValue.connectionType,
      iab_bcat: [...blockedIabCategories],
      iab_cat: [...iabCategories],
      adapter_id: this.formValue.adapter_id,
      adapter_config: this.adaptersFields.length > 0 ? this.buildAdapterConfig() : null,
      dspList: modifiedDSPList,
    };
  }

  private updateEndpoint(rtbEndpointData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedRTBFields, checkboxesRTB, rtbEndpointData), 'ssp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err),
      );
  }

  private handleSuccessResponse(resp: any, callback: (type: string) => void): void {
    this.showNotification('success', 'success', 'success', 'SSP', resp.data.name, 'updated', '385px', 4500, 'bold');
    callback('updated');
    this.tabIndex = 0;
    this.editSSPForm.reset();
    this.adaptersRtb = [];
    this.isDisableSubmit = false;
  }

  private handleErrorResponse(err): void {
    this.isDisableSubmit = false;
    this.errorsHandlingService.handleError(err);
  }

  private patchAdTypeValues(): void {
    ['ctv', 'mobile_web', 'desktop', 'mobile_app'].forEach(adType => {
      this.editSSPForm.get(adType)?.patchValue(this.adTypeControl.value === adType);
    });
  }

  private cleanupVASTFormValue(): void {
    delete this.formValue.rtbConnectionMode;
  }

  private prepareVastData(modifiedDSPList: number[]): any {
    const iabCategories = getStringCheckedKeys(this.iabCategories);
    return {
      ...this.formValue,
      dspList: modifiedDSPList,
      iab_cat: [...iabCategories],
      vast: {
        ...this.formValue.vast,
        ctv: this.formValue.ctv ? 1 : 0,
        mobile_web: this.formValue.mobile_web ? 1 : 0,
        desktop: this.formValue.desktop ? 1 : 0,
        mobile_app: this.formValue.mobile_app ? 1 : 0,
        startdelay: this.formValue.vast.startdelay === 1 ? this.formValue.vast.startdelaymid : this.formValue.vast.startdelay,
        is_rewarded: !this.formValue['rewarded'] ? undefined : this.formValue.vast.is_rewarded ? 1 : 0
      }
    };
  }

  private updateVastEndpoint(vastData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedVastFields, vastCheckboxes, vastData), 'ssp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err),
      );
  }

  private patchJSAdTypeValues(): void {
    const adTypeMappings = {
      'mobile_web': 'mobile_web',
      'desktop': 'desktop',
      'mobile_app': 'mobile_app'
    };

    Object.entries(adTypeMappings).forEach(([formControlName, adTypeValue]) => {
      this.formControls[formControlName].patchValue(this.jsAdTypeControl.value === adTypeValue);
    });
  }

  private cleanupJSFormValue(): void {
    delete this.formValue.vastConnectionMode;
    delete this.formValue.rtbConnectionMode;
  }

  private prepareJSData(modifiedDSPList: number[], blockedIabCategories: string[], iabCategories: string[]): any {
    return {
      ...this.formValue,
      dspList: modifiedDSPList,
      iab_bcat: [...blockedIabCategories],
      iab_cat: [...iabCategories],
      js: {
        ...this.formValue.js,
        mobile_web: this.formValue.mobile_web ? 1 : 0,
        desktop: this.formValue.desktop ? 1 : 0,
        mobile_app: this.formValue.mobile_app ? 1 : 0,
      }
    };
  }

  private updateJSEndpoint(jsData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedJsFields, jsCheckboxes, jsData), 'ssp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err),
      );
  }

  private cleanupPreBidFormValue(): void {
    delete this.formValue.vastConnectionMode;
    delete this.formValue.rtbConnectionMode;
  }

  private preparePreBidData(modifiedDSPList: number[], blockedIabCategories: string[], iabCategories: string[]): any {
    return {
      ...this.formValue,
      dspList: modifiedDSPList,
      iab_bcat: [...blockedIabCategories],
      iab_cat: [...iabCategories],
    };
  }

  private updatePreBidEndpoint(prebidData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedPreBidFields, preBidCheckboxes, prebidData), 'ssp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err),
      );
  }

  private modifyReqData(removedFields: string[], checkboxes: string[], reqObject: { [key: string]: any }): { [key: string]: any } {
    let requestBody: { [key: string]: any } = {};
    for (const key of Object.keys(reqObject)) {
      if (key !== 'adapter_config') {
        if (removedFields.includes(key) || reqObject[key] === null || reqObject[key] === undefined) {
          delete reqObject[key];
          continue;
        }
      }

      if (checkboxes.includes(key)) {
        reqObject[key] = reqObject[key] ? 1 : 0;
        continue;
      }

      if (key === 'pixalate_pb_settings' && typeof reqObject[key] === 'object') {
        for (const innerKey of Object.keys(reqObject[key])) {
          if (checkboxes.includes(innerKey)) {
            const innerValue = reqObject[key][innerKey];
            reqObject[key][innerKey] = innerValue ? 1 : 0;
          }
        }
      }
    }

    requestBody = { ...reqObject };

    return requestBody;
  }

  private createForm(): void {
    this.editSSPForm = this.dynamicFormService.createEditSSPForm();
    this.formControls['name'].addValidators([ErrorValidator.cannotContainSpace]);
  }

  private validateMultiAdResponses(errorMessages: string[]): string[] {
    if (this.formControls['is_multi_ad_response']?.value) {
      const multiAdControl = this.editSSPForm.get('multi_ad_responses');
      if (multiAdControl?.value === null || multiAdControl?.value === undefined || multiAdControl?.value === '') {
        errorMessages.push('Maximum Bids per response is required when Multi-bid response logic is enabled');
        multiAdControl?.setErrors({ invalid: true });
      } else if (multiAdControl?.invalid) {
        errorMessages.push('Maximum Bids per response must be between 2 and 10');
      }
    }
    return errorMessages;
  }

  private showNotification(
    iconType: string,
    color: string,
    notificationType: string,
    leftPartOfText: string,
    description: string,
    rightPartOfText: string,
    width: string,
    duration: number,
    fontWeight: string,
  ): void {
    const data = {
      iconType,
      color,
      notificationType,
      description,
      leftPartOfText: leftPartOfText ?? '',
      rightPartOfText: rightPartOfText ?? '',
      fontWeight: fontWeight ?? 'normal'
    };

    this.notificationComponent.data = data;
    this.notificationService.showTemplate({ nzData: data, nzStyle: { width: width ?? '385px' }, nzDuration: duration ?? 4500 });
  }

  private jsTagTypeChanged(type: string): void {
    if (type === 'direct') {
      this.selectedMacrosesCache = this.selectedJs;
      this.selectedJs = [];
      return;
    }

    const typeToMacrosMap = {
      'web': this.macrosListScriptWeb,
      'app': this.macrosListApp,
      'serverApp': this.macrosListApp,
      'serverWeb': this.macrosListScriptWeb,
      'googleAd': this.macrosListGoogleAds,
      'mobup': this.macrosListMobup
    };

    const selectedMacrosList = typeToMacrosMap[type];
    if (selectedMacrosList) {
      this.macrosListJs = selectedMacrosList;
      this.macrosListDialogJs = selectedMacrosList;
    }
  }

  private updatePixalatePBSettingsGroup(data: PlatformInterface.IEndpointPixalatePreBidSettings) {
    const fieldsToUpdate = [
      'ip', 'ifa', 'ua', 'ott', 'def_app', 'domain', 'hr_app', 'dc_subnet'
    ];

    const patchValue = fieldsToUpdate.reduce((acc, field) => ({
      ...acc,
      [field]: data[field] === 1,
      [`${field}_percent`]: data[field] === 1 ? data[`${field}_percent`] : 0,
    }), {});

    this.editSSPForm.get('pixalate_pb_settings')?.patchValue(patchValue);
  }

  private modifyFilterListsArray(data: MainDashboardInterface.IEditSSPDialog): void {
    const filterLists = data.filterLists;
    this.filterLists = rearrangeFilterListItems(filterLists, this.formValue['filter_list_ids']);
  }

  private setArrayOfMargins(): void {
    const marginTypes = {
      'range': [
        { key: 'min_margin', minValue: 1, maxValue: 100 },
        { key: 'max_margin', minValue: 1, maxValue: 100 }
      ],
      'fixed': [
        { key: 'margin', minValue: 0, maxValue: 100 }
      ],
      'adaptive': []
    };

    this.arrayOfMargins = marginTypes[this.formValue['margin_type']] || [];
  }

  private setWritingPubIds(writing_pub_ids: string): void {
    const value = this.formValue.hasOwnProperty('writing_pub_ids') ? writing_pub_ids : 'automated';
    this.formControls['writing_pub_ids'].patchValue(value);
  }

  private setPartnerName(prebid_params: PlatformInterface.IPreBidParams): void {
    const partnerName = prebid_params ? prebid_params.name : '';
    this.formControls['partnerName'].patchValue(partnerName);
  }

  private setProtocol(): void {
    this.protocol = this.partnerSettings.useSsl ? 'https://' : 'http://';
  }

  private setVast(): void {
    this.getAdType();
    this.patchSelectedSizes();
    this.vastControls['adServerId'].value !== null ? this.populateMacrosList() : this.updateMacrosList();
  }

  private patchSelectedSizes(): void {
    const sizeValue = this.vastFormGroupValue['h'] == null || this.vastFormGroupValue['w'] == null ? '0' : '1';
    this.selectedSizesControl.patchValue(sizeValue);
  }

  private populateMacrosList(): void {
    this.macrosListVast = [];
    this.vastFormGroupValue['adServer'].macroses.forEach(item => {
      if (item[this.adTypeControl.value] === 1) {
        const macros = item.showAttr === 0 ? item.macros : item.shortcut;
        this.macrosListVast.push({
          id: macros,
          name: macros,
          mobile_web: item.mobile_web,
          desktop: item.desktop,
          mobile_app: item.mobile_app,
          ctv: item.ctv,
          desc: '',
        });
        this.urlAttrsVast[macros] = item.shortcut;
      }
    });
  }

  private updateMacrosList(): void {
    this.listOfMacros = [];
    const macrosList = this.getMatchingElements(this.macrosListVast, this.formValue.vast.macrosList);
    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.listOfMacros.push(
      {
        id: '[IP]',
        name: '[IP]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'IPv4 address closest to device',
      },
    );
    this.listOfMacros.push(
      {
        id: '[UA]',
        name: '[UA]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'Browser user agent string.',
      },
    );
    const selected = macrosList.map(macros => macros.id);
    this.vastControls['macrosList'].patchValue(selected);
  }

  private setRtb(resp: PlatformInterface.IResponseSSPById): void {
    if (!this.formValue.adapter_id) {
      this.formControls['adapter_id'].patchValue(0);
    }
    this.getSSPAdapters(resp);
  }

  private setSelectedMacrosList(): void {
    this.processMacrosListVast();
  }

  private processMacrosListVast(): void {
    const initialAcc: AccType = { selectedMacros: [], macroses: [] };

    const { selectedMacros } = this.macrosListVast.reduce((acc: AccType, item) => {
      if (item[this.adTypeControlValue]) {
        acc.macroses.push(item);
        if (item.name !== '[BIDFLOOR]') {
          acc.selectedMacros.push(item.id);
        }
      }
      return acc;
    }, initialAcc);

    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.formControls['vast']?.get('macrosList')?.patchValue(selectedMacros);

    this.appendVastMacroses(selectedMacros);
  }

  private appendVastMacroses(selectedMacrosList: string[]): void {
    let url = `${this.protocol}${this.partnerSettings.ns}/?seat=${this.formValue.seat}&token=${this.setOriginalEndpointUrl()}`;
    selectedMacrosList.forEach(item => {
      if (item !== '[BIDFLOOR]') {
        url += `&${urlVastAttributes[item]}=${item}`;
      }
    });

    this.formControls['endpoint'].patchValue(url);
  }

  private setShowStatusForPartnerName(endpointCreated: string): void {
    if (this.partnerSettings.prebidIntegration) {
      const { wl_prebid, wl_prebid_time, js_prebid, js_prebid_time } = this.partnerSettings.prebidIntegration;

      const endpointCreatedTime = new Date(endpointCreated).getTime();
      const wlPrebidTime = wl_prebid_time ? new Date(wl_prebid_time + 'Z').getTime() : null;
      const jsPrebidTime = js_prebid_time ? new Date(js_prebid_time + 'Z').getTime() : null;

      // Logic for wl_prebid
      if (wl_prebid === null || wl_prebid === 0) {
        this.isShowPartnerNameForPrebid = true;
      } else if (wl_prebid === 1) {
        if (wlPrebidTime === null) {
          this.isShowPartnerNameForPrebid = true;
        } else if (endpointCreatedTime < wlPrebidTime) {
          this.isShowPartnerNameForPrebid = true;
        } else {
          this.isShowPartnerNameForPrebid = false;
        }
      }

      // Logic for js_prebid
      if (js_prebid === null || js_prebid === 0) {
        this.isShowPartnerNameForPrebidJS = true;
      } else if (js_prebid === 1) {
        if (jsPrebidTime === null) {
          this.isShowPartnerNameForPrebidJS = true;
        } else if (endpointCreatedTime < jsPrebidTime) {
          this.isShowPartnerNameForPrebidJS = true;
        } else {
          this.isShowPartnerNameForPrebidJS = false;
        }
      }
    }
  }

  private showLoading(): void {
    this.loadingService.show();
  }

  private hideLoading(): void {
    this.loadingService.hide();
  }

  private processSSPData(r: any, data: MainDashboardInterface.IEditSSPDialog): void {
    this.setSubmitStatus(r.data);
    this.updateFormWithSSPData(r.data);
    this.updatePixalateSettings(r.data);
    this.updatePartnerSettings(r.data);
    this.updateFormValues(r.data, data);
    this.updateFixedBidPrice(r.data);
    this.handleConnectionType(r);
  }

  private setSubmitStatus(data: any): void {
    const restrictedConnectionTypes = [4, 5];
    this.isDisableSubmit = !!data.deletedAt || (this.partner?.partner_plan === 3 && restrictedConnectionTypes.includes(data.connectionType));

    const restrictionRegions = ['APAC', 'EU'];
    if (restrictionRegions.includes(data.region) && this.partner?.partner_plan === 3) {
      this.isDisableSubmit = true;
      this.isDisableDuplicate = true;
    }
  }

  private updateFormWithSSPData(data: any): void {
    this.editSSPForm = this.dynamicFormService.endpointFormWithValues(this.editSSPForm, data, checkboxesForUpdateForm);

    this.setShowStatusForPartnerName(data.createdAt);

    this.getCompaniesForDropdowns(this.formValue.region, data);
  }

  private updateDSPDropdown(data: any): void {
    if (this.companiesDSPDropdown.length) {
      const updatedCompanies = this.getUpdatedCompanies(data.dspList as number[]);
      this.companiesDSPDropdown = JSON.parse(JSON.stringify(updatedCompanies));
      const modifiedDspList = getStringCheckedKeys(this.companiesDSPDropdown);
      this.editSSPForm.get('dspList')?.patchValue(modifiedDspList);
    }
  }

  private getUpdatedCompanies(dspList: number[]): any[] {
    const arrayCompanies = JSON.parse(JSON.stringify(this.companiesDSPDropdown));
    const updatedCompanies = updateCheckedStatus([...arrayCompanies], dspList);
    return rearrangeCompaniesItems([...updatedCompanies], dspList);
  }

  private updatePixalateSettings(data: any): void {
    if (data.pixalate_pb_settings) {
      this.updatePixalatePBSettingsGroup(data.pixalate_pb_settings);
    }
  }

  private updatePartnerSettings(data: any): void {
    const domain = this.partnerSettings.domains?.find(domain => domain.region === data.region);
    this.partnerSettings.ns = domain?.ns ?? '';
  }

  private updateFormValues(res: any, data: MainDashboardInterface.IEditSSPDialog): void {
    this.iabCategories = res['iab_cat'] ?? [];
    this.formControls['iab_cat'].patchValue(this.getIABCategoriesCheckedKeys());
    this.formControls['has_new_iab_categories'].patchValue(this.formValue.iab_cat.length > 0);

    this.modifyFilterListsArray(data);
    this.setArrayOfMargins();
    this.setWritingPubIds(res.writing_pub_ids);
    this.blockedIabCategories = res['iab_bcat'] ?? [];
    this.formControls['iab_bcat'].patchValue(this.getBlockedIabCategoriesCheckedKeys());

    this.setPartnerName(res.prebid_params);
    this.setProtocol();
    this.cookieSync = this.formValue.cookieSync;

    if (this.formValue.defaultBidfloor == null) {
      this.formControls['defaultBidfloor'].patchValue(0);
    }

    if (this.isVastConnection()) {
      this.onChangeVastMacrosByFormat(this.formValue['isVideo']);

      if (this.formValue['isAudio']) {
        this.mimesItems = MIMES_AUDIO_ITEMS;
      } else {
        this.mimesItems = DEFAULT_MIMES_ITEMS;
      }
    }

    if (this.partner?.partner_plan === 3) {
      this.formControls['has_demand_booster'].disable({ emitEvent: false });
      this.formControls['has_maximised_bidprice'].disable({ emitEvent: false });
      this.formControls['has_demand_booster'].patchValue(false, { emitEvent: false });
      this.formControls['has_maximised_bidprice'].patchValue(false, { emitEvent: false });
    }

    if (this.isVastConnection() && res.vast.startdelay > 0) {
      this.formControls['vast'].get('startdelaymid')?.patchValue(res.vast.startdelay, { emitEvent: false });
      this.formControls['vast'].get('startdelay')?.patchValue(1, { emitEvent: false });
    }

    this.updateControlsStateBaseOnFormat();
  }

  private removeNonEnterpriseFields(vastDataEndpoint: any): void {
    if (this.partner.partner_plan !== 1) {
      const controlKeys = [
        'is_rewarded',
        'skip',
        'skipmin',
        'skipafter',
        'minduration',
        'maxduration',
        'startdelay',
        'placement',
        'plcmt',
        'mimes',
        'pos',
        'playbackmethod',
        'startdelaymid',
        'protocols',
        'api'
      ];

      controlKeys.forEach(controlKey => {
        delete vastDataEndpoint.vast[controlKey];
      });
    }

    return vastDataEndpoint;
  }

  private updateControlsBasedOnPartnerPlan(): void {
    const vastControls = this.formControls['vast'];

    if (!vastControls) {
      return;
    }

    const controlKeys = [
      'is_rewarded',
      'skip',
      'skipmin',
      'skipafter',
      'minduration',
      'maxduration',
      'startdelay',
      'placement',
      'plcmt',
      'mimes',
      'pos',
      'playbackmethod',
      'protocols',
      'api'
    ];

    const isEnterprisePlan = this.partner?.partner_plan === 1;

    const isActiveOneFormat = this.formValue['rewarded'] || this.formValue['isVideo'] || this.formValue['isAudio'];

    controlKeys.forEach(controlKey => {
      const control = vastControls.get(controlKey) as FormControl;

      if (!control) {
        return;
      }

      if (isEnterprisePlan) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
        return;
      }

      if (!isActiveOneFormat) {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false });
      }
    });

    if (!isEnterprisePlan) {
      return;
    }

    const defaultValuesForNonEnterprisePlan: { [key: string]: any } = {
      is_rewarded: false,
      skip: 0,
      skipmin: null,
      skipafter: null,
      minduration: null,
      maxduration: null,
      startdelay: null,
      placement: null,
      plcmt: null,
      mimes: [],
      pos: null,
      playbackmethod: [],
      protocols: [],
      api: []
    };

    const defaultValuesForEnterprisePlan: { [key: string]: any } = {
      is_rewarded: false,
      skip: 0,
      skipmin: 0,
      skipafter: 0,
      minduration: 3,
      maxduration: 300,
      startdelay: null,
      placement: null,
      plcmt: null,
      mimes: ['video/mp4', 'video/mpeg', 'video/ogg', 'video/webm', 'application/javascript'],
      pos: 1,
      playbackmethod: [],
      protocols: [2, 3, 5, 6, 7, 8, 11, 12, 13, 14, 15, 16],
      api: []
    };

    const valuesToApply = isEnterprisePlan ? defaultValuesForEnterprisePlan : defaultValuesForNonEnterprisePlan;

    const enabledAudioControl = [
      'minduration',
      'maxduration',
      'mimes',
      'protocols',
      'api'
    ];

    Object.entries(valuesToApply).forEach(([controlKey, value]) => {
      const control = vastControls.get(controlKey) as FormControl;

      if (control) {
        control.patchValue(value, { emitEvent: false });
      }
    });

    if (!this.formValue['rewarded']) {
      vastControls.get('is_rewarded')?.disable({ emitEvent: false });
    } else {
      vastControls.get('is_rewarded')?.enable({ emitEvent: false });
    }

    if (this.formValue['isAudio']) {
      controlKeys.forEach(controlKey => {
        vastControls.get(controlKey)?.disable({ emitEvent: false });
      });

      enabledAudioControl.forEach(control => {
        vastControls.get(control)?.enable({ emitEvent: false });
        vastControls.get('mimes')?.patchValue(['audio/mp4']);
      });
    }
  }

  private updateControlsStateBaseOnFormat(): void {
    const vastControls = this.formControls['vast'];

    if (!vastControls) {
      return;
    }

    const controlKeys = [
      'is_rewarded',
      'skip',
      'skipmin',
      'skipafter',
      'minduration',
      'maxduration',
      'startdelay',
      'placement',
      'plcmt',
      'mimes',
      'pos',
      'playbackmethod',
      'protocols',
      'api'
    ];

    const enabledAudioControl = [
      'minduration',
      'maxduration',
      'mimes',
      'protocols',
      'api'
    ];

    const isEnterprisePlan = this.partner?.partner_plan === 1;

    controlKeys.forEach(controlKey => {
      const control = vastControls.get(controlKey) as FormControl;

      if (!control) {
        return;
      }

      if (isEnterprisePlan) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    });

    if (!this.formValue['rewarded']) {
      vastControls.get('is_rewarded')?.disable({ emitEvent: false });
    } else {
      vastControls.get('is_rewarded')?.enable({ emitEvent: false });
    }

    if (this.formValue['isAudio']) {
      controlKeys.forEach(controlKey => {
        vastControls.get(controlKey)?.disable({ emitEvent: false });
      });

      enabledAudioControl.forEach(control => {
        vastControls.get(control)?.enable({ emitEvent: false });
      });
    }
  }

  private updateFixedBidPrice(data: any): void {
    if (this.formValue.fixedPrice) {
      this.fixedBidPriceControl.patchValue(data.defaultBidfloor);
    }
  }

  private handleConnectionType(resp: PlatformInterface.IResponseSSPById): void {
    if (this.isRTBConnection()) {
      this.setRtb(resp);
    }

    if (this.isJSConnection()) {
      this.handleJs();
    }

    if (this.formValue.connectionType === 1) {
      this.setVast();
    }
  }

  private setOriginalEndpointUrl() {
    if (this.vastControls['adServerId'].value === null) {
      return this.formValue.secretKey + '&cb=[CB]&ua=[UA]&ip=[IP]&w=[WIDTH]&h=[HEIGHT]';
    } else {
      return this.formValue.secretKey;
    }
  }

  private initializeDropdowns(data: MainDashboardInterface.IEditSSPDialog): void {
    this.endpointId = data.endpointId;
    this.getEndpointById(data);
  }

  private filterCompanies(data: MainDashboardInterface.IEditSSPDialog): void {
    this.companies = data.companies.filter(company => company.id !== -1);
  }

  private loadPartnerSettings(data: MainDashboardInterface.IEditSSPDialog): void {
    this.partnerSettings = data.partnerSettings;
  }

  private loadOptions(): void {
    this.categories = this.options.getCategoriesForAutologger();
    this.regions = this.mainService.regions;
    this.listOfSizes = this.options.getListOfSizes() as any;
    this.isRequiredCompany = false;
    this.isRequiredRegion = false;
    this.isRequiredAdFormat = false;
    this.isRequiredTrafficType = false;
    this.isOpenMacros = false;
    this.tabIndex = 0;
    this.adaptersRtb = [];
    this.getIABCategories();
  }

  private loadAuthDetails(): void {
    this.userRole = this.auth.userRole;
    this.partner = this.auth.partner;
  }

  private handleMarginType(): void {
    switch (this.formValue.margin_type) {
      case 'range':
        this.formControls['margin'].patchValue(undefined);
        break;
      case 'fixed':
        this.clearMarginFields(['min_margin', 'max_margin']);
        break;
      case 'adaptive':
        this.clearMarginFields(['min_margin', 'max_margin', 'margin']);
        break;
    }
  }

  private clearMarginFields(fields: string[]): void {
    fields.forEach(field => this.formControls[field].patchValue(undefined));
  }

  private handleSubmitByConnectionType(modifiedDSPList: any[], callback: (type: string) => void): void {
    switch (this.formValue.connectionType) {
      case 0:
        this.onSubmitRTB(modifiedDSPList, callback);
        break;
      case 1:
        this.onSubmitVast(modifiedDSPList, callback);
        break;
      case 3:
        this.onSubmitJS(modifiedDSPList, callback);
        break;
      case 4:
      case 5:
        this.onSubmitPreBid(modifiedDSPList, callback);
        break;
    }
  }

  private onChangeVastMacrosByFormat(value: boolean): void {
    if (value) {
      this.macrosListVast = this.macrosListVast.filter(item => item.id !== '[FEED]');
      const macrosList = this.editSSPForm.get('vast')?.get('macrosList')?.value.filter(item => item !== '[FEED]') || [];
      this.editSSPForm.get('vast')?.get('macrosList')?.patchValue(macrosList, { emitEvent: false });
      this.onChangeVastMacrosHandler(macrosList);
    } else {
      this.macrosListVast = defaultMacrosListVast;
    }
    this.listOfMacros = this.macrosListVast.map(macros => macros);
  }

  private showSuccessNotificationAndCloseModal(message: string): void {
    this.showNotification('success', 'success', 'success', '', message, '', '385px', 4500, 'normal');
    this.modalService.closeAll();
  }

  private resetAdaptersFields(): void {
    this.adaptersFields = [];
  }

  private initializeAdaptersFields(): void {
    this.adaptersFields = this.adaptersRtb.map(item => ({
      field: item.field,
      id: item.name,
      config: item.config
    }));
  }

  private findAdapterItem(server: string | number): void {
    const adaptersItem = this.rtbServers.find(item => item.id === server) || null;
    if (adaptersItem) {
      this.adaptersItem = adaptersItem;
      this.selectedAdapterName = adaptersItem.name;
    }
  }

  private setupAdaptersRtb(): void {
    if (!this.adaptersItem || !this.adaptersItem.fields || this.adaptersItem.fields.length === 0) {
      this.adaptersRtb = [];
      this.isShowFields = false;
      return;
    }

    this.adaptersRtb = this.adaptersItem.fields.map(field => ({
      name: field,
      field: null as any as string,
      id: field,
      config: field,
      tooltip: this.adaptersItem.config.paramsReq[field]?.tooltip ?? null,
    }));

    this.isShowFields = this.adaptersRtb.length > 0;
  }

  private setRtbAdapters(resp: PlatformInterface.IResponseSSPById): void {
    const object = JSON.parse(resp.data.adapter_config);
    if (object) {
      const array = Object.entries(object);
      this.adaptersRtb = array.map((item, index) => {
        return {
          name: item[0],
          field: item[1],
          id: index++,
          tooltip: this.adaptersItem.config.paramsReq[item[0]].tooltip ?? null
        };
      });
    } else {
      this.adaptersRtb = [];
    }

    this.isShowFields = this.adaptersRtb.length > 0;
  }

  private createDeleteEndpointDialog(endpoint: PlatformInterface.IPlatformSSP) {
    return this.modalService.create({
      nzContent: DeleteEndpointConfirmComponent,
      nzStyle: { top: '200px', width: '450px', height: '170px' },
      nzBodyStyle: { width: '450px', height: '170px' },
      nzClassName: 'delete-endpoint-modal',
      nzWrapClassName: 'delete-endpoint-modal-wrap',
      nzClosable: false,
      nzMaskClosable: false,
      nzData: {
        entity: 'endpoint', name: endpoint.name,
      }
    });
  }

  private handleDialogClose(dialogRef, endpoint: PlatformInterface.IPlatformSSP, callback: (type: string) => void): void {
    dialogRef.afterClose.subscribe(res => {
      if (res) {
        this.deleteEndpoint(endpoint, callback);
      }
    });
  }

  private handleCookieSync(): void {
    if (this.cookieSync && (this.cookieSync).endpoint) {
      this.mainService.saveSSPCookieSync(this.cookieSync)
        .subscribe(
          data => { this.cookieSync = data.cookieSync; },
          error => this.errorsHandlingService.handleError(error)
        );
    }
  }

  private fetchSSPData(): Observable<any> {
    return this.mainService.getSSP(this.endpointId)
      .pipe(finalize(() => this.hideLoading()));
  }

  private getDSPEndpoints(): void {
    this.mainService.getEndpointItemsReq()
      .subscribe(data => {
        this.dspList = data.dsp;
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getEndpointById(data: MainDashboardInterface.IEditSSPDialog): void {
    this.showLoading();
    this.fetchSSPData()
      .subscribe(res => {
        this.processSSPData(res, data);
      },
        error => this.errorsHandlingService.handleError(error));
  }

  private getSSPAdapters(resp: PlatformInterface.IResponseSSPById): void {
    this.mainService.getAdaptersByType({ is_prebid: false, type: 'ssp' })
      .subscribe(
        res => {
          this.processAdaptersResponse(res);
          this.updateAdaptersForRubicon();
          this.setSelectedAdapter();
          this.setRtbAdapters(resp);
        },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private onSubmitRTB(modifiedDSPList: number[], callback: (type: string) => void): void {
    this.initializeAdaptersFields();
    this.cleanupRBTFormValue();
    this.setupRTBEndpoint();

    const fields = this.buildAdapterConfig();
    if (!fields) {
      this.isDisableSubmit = false;
      return;
    }

    const rtbEndpointData = this.prepareRTBEndpointData(modifiedDSPList);
    this.updateEndpoint(rtbEndpointData, callback);
  }

  private onSubmitVast(modifiedDSPList: number[], callback: (type: string) => void): void {
    this.patchAdTypeValues();
    this.cleanupVASTFormValue();
    let vastData = this.prepareVastData(modifiedDSPList);

    if (vastData.vast.startdelaymid) {
      delete vastData.vast.startdelaymid;
    }

    vastData = this.removeNonEnterpriseFields(vastData);

    this.updateVastEndpoint(vastData, callback);
  }

  private onSubmitJS(modifiedDSPList: number[], callback: (type: string) => void): void {
    this.patchJSAdTypeValues();
    const blockedIabCategories = getStringCheckedKeys(this.blockedIabCategories);
    const iabCategories = getStringCheckedKeys(this.iabCategories);
    this.cleanupJSFormValue();
    const jsData = this.prepareJSData(modifiedDSPList, blockedIabCategories, iabCategories);
    this.updateJSEndpoint(jsData, callback);
  }

  private onSubmitPreBid(modifiedDSPList: number[], callback: (type: string) => void): void {
    const blockedIabCategories = getStringCheckedKeys(this.blockedIabCategories);
    const iabCategories = getStringCheckedKeys(this.iabCategories);
    this.cleanupPreBidFormValue();
    const prebidData = this.preparePreBidData(modifiedDSPList, blockedIabCategories, iabCategories);
    this.updatePreBidEndpoint(prebidData, callback);
  }

  private deleteEndpoint(endpoint: PlatformInterface.IPlatformSSP, callback: (type: string) => void): void {
    this.loadingService.show();
    this.mainService.deleteEndpointReq(endpoint.id, 'ssp')
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(
        () => {
          this.showNotification('success', 'success', 'success', '', 'Endpoint deleted!', '', '385px', 4500, 'normal');
          callback('updated');
          this.modalService.closeAll();
        },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getCompaniesForDropdowns(region: string, data: PlatformInterface.IPlatformSSP): void {
    this.getCompaniesForDropdownsReq(region).subscribe(res => {
      this.companiesDSPDropdown = transformArray(res.dsp);

      this.updateDSPDropdown(data);
    },
      error => this.errorsHandlingService.handleError(error));
  }

  private getCompaniesForDropdownsReq(region: string): Observable<MainDashboardInterface.CompaniesDataRes> {
    const params = new HttpParams().append('without_deleted', true);

    return this.http.get<MainDashboardInterface.CompaniesDataRes>(`${this.apiUrl}/endpoints/grouped-by-company/dsp/${region}`, { params: params })
      .pipe(map(res => {
        res.dsp = res.dsp.map(company => {
          company.endpoints = company.endpoints.map(endpoint => {
            return { checked: false, disabled: false, label: endpoint.name, value: endpoint.id, ...endpoint };
          });
          return { checked: false, label: company.name, value: company.id, indeterminate: false, ...company };
        });

        return res;
      }),
        catchError(this.errorsHandlingService.processError));
  }
}
